import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DeliveryMethodDataGrid } from "src/components/views/erp/warehouse/masterData/DeliveryMethodDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/warehouse/deliveryMethods")({
	staticData: { title: i18n.t("delivery_methods"), legacyViewKey: "deliveryMethodDataGrid" },
	component: RouteComponent,
});

function RouteComponent() {
	return <DeliveryMethodDataGrid />;
}
